import moment from 'moment';

export default ({
	EN: {
		calendarHeader: date => moment.utc(new Date(date)).format('MMMM YYYY'),
		lastMonthLabel: 'Last Month',
		nextMonthLabel: 'Next Month',
		days: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
		legendText: 'shows all availabilities',
		pageTitle: 'Schedule'
	},
	ES: {
		calendarHeader: date => moment.utc(new Date(date)).format('MMMM YYYY'),
		lastMonthLabel: 'El Mes Pasado',
		nextMonthLabel: 'Próximo Mes',
		days: ['SUN', 'MON', 'TUE', 'WED', 'THU', 'FRI', 'SAT'],
		legendText: 'muestra todas las disponibilidades',
		pageTitle: 'Calendario'
	}
});
